import { render, staticRenderFns } from "./privados.vue?vue&type=template&id=0bb2d70b"
import script from "./privados.vue?vue&type=script&lang=js"
export * from "./privados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports